var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVitanoAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "65px",
    viewBox: "0 0 64 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vita noAward") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vita-noAward"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 0.449362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg-heart-icon-2",
    transform: "translate(12.444444, 17.777778)",
    fillRule: "nonzero",
    fill: "#27BF5B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0.832151, 0.037825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6028369,25.7588652 L3.06382979,17.2198582 C-0.85106383,13.3049645 -0.85106383,6.92198582 3.06382979,3.0070922 L3.06382979,3.0070922 C6.9787234,-0.907801418 13.3617021,-0.907801418 17.2765957,3.0070922 L25.8156028,11.5460993 C29.7304965,15.4609929 29.7304965,21.8439716 25.8156028,25.7588652 L25.8156028,25.7588652 C21.929078,29.6453901 15.5177305,29.6453901 11.6028369,25.7588652 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6028369,11.5460993 L20.141844,3.0070922 C24.0567376,-0.907801418 30.4397163,-0.907801418 34.3546099,3.0070922 L34.3546099,3.0070922 C38.2695035,6.92198582 38.2695035,13.3049645 34.3546099,17.2198582 L25.8156028,25.7588652 C21.9007092,29.6737589 15.5177305,29.6737589 11.6028369,25.7588652 L11.6028369,25.7588652 C7.71631206,21.8439716 7.71631206,15.4326241 11.6028369,11.5460993 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7304965,31.858156 L10.1276596,24.2553191 C9.58865248,23.7163121 9.58865248,22.8085106 10.1276596,22.2411348 L17.7304965,14.6382979 C18.2695035,14.0992908 19.177305,14.0992908 19.7446809,14.6382979 L27.3475177,22.2411348 C27.8865248,22.7801418 27.8865248,23.6879433 27.3475177,24.2553191 L19.7446809,31.858156 C19.177305,32.3971631 18.2695035,32.3971631 17.7304965,31.858156 Z",
    id: "Shape"
  })))), /*#__PURE__*/React.createElement("polyline", {
    id: "Page-1",
    stroke: "#FEFEFE",
    strokeWidth: 1.48088889,
    strokeLinejoin: "round",
    points: "2.66666667 33.0170992 23.3179569 33.0170992 27.6884208 25.1208513 31.9438725 40.6569265 36.9073091 29.0604907 40.8488341 32.4109283 62.2015102 32.4109283"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitanoAward);
export default __webpack_public_path__ + "static/media/Vita noAward.f82ca5fce33c24c671b916cd25bb8802.svg";
export { ForwardRef as ReactComponent };